import { call, put, take, fork } from 'redux-saga/effects';
import { api } from 'rp-auth';
import { showLightbox } from '../actions/lightbox';
import {
  subscriptionRenewFailed,
  subscriptionRenewSucceeded,
  SUBSCRIPTION_RENEW_REQUESTED,
} from '../actions/subscriptions';

const { renewSubscription } = api;

export function* renewSubscriptionSaga({ payload }) {
  try {
    const userSubscription = yield call(renewSubscription, payload);
    yield put(subscriptionRenewSucceeded(userSubscription));
    yield put(showLightbox());
  } catch (error) {
    yield put(subscriptionRenewFailed(error));
  }
}

export function* watchRenewSubscription() {
  while (true) {
    const action = yield take(SUBSCRIPTION_RENEW_REQUESTED);
    yield fork(renewSubscriptionSaga, action);
  }
}
